import "./upsellPage.scss";

import React, { lazy, Suspense, useState } from "react";
import { useDispatch } from "react-redux";

import { PageConsultation } from "@components/layouts/PageConsultation";
import { OnNextPayload } from "@components/Questionnaire";
import { useTitle } from "@hooks/useTitle";
import { AlertBanner, Button, Title } from "@runwayhealth/runway-components-react";
import { addConditions } from "@store/cases/casesSlice";
import { RecommendedConditions } from "@types-runway/case";
import { Condition } from "@types-runway/condition";
import { WarningMessage } from "@types-runway/questionnaire";
import { uniqueConditions } from "@utils/case/uniqueConditions";

// Lazy components
const Cart = lazy(() => import("@components/Cart/index"));

type UpsellPageProps = {
  title: string;
  visitFeeDiscount?: number;
  onNext: (payload?: OnNextPayload) => void;
  addonRecommendations: RecommendedConditions;
  warningMessage?: WarningMessage;
};

const UpsellPage: React.FC<UpsellPageProps> = ({
  title,
  visitFeeDiscount,
  onNext,
  addonRecommendations,
  warningMessage,
}) => {
  useTitle("Recommended Meds");
  const dispatch = useDispatch();
  const [addonConditions, setAddonConditions] = useState<Condition[]>([]);

  const submitSelections = () => {
    const selectedConditions = uniqueConditions(addonConditions);
    sessionStorage.setItem("upsoldConditions", JSON.stringify(selectedConditions));
    dispatch(addConditions(selectedConditions));
    onNext({ addonConditions: selectedConditions });
  };

  return (
    <>
      <div className="upsell-page-wrapper">
        <PageConsultation.Header>
          <Title size="giant">{title}</Title>
        </PageConsultation.Header>

        <PageConsultation.Body>
          <div className="upsell-page-body">
            <div className="wrapper">
              <Suspense fallback={<div>Loading...</div>}>
                <Cart
                  country={""}
                  variant="upsell"
                  preselectedConditions={addonRecommendations.conditions}
                  addonConditions={addonConditions}
                  setAddonConditions={setAddonConditions}
                  visitFeeDiscount={visitFeeDiscount}
                  cartItemPresentationStyle="selector"
                  warningMessage={warningMessage}
                />
              </Suspense>
              <AlertBanner variant="info" className="warning-banner" isRounded>
                <AlertBanner.Message>
                  {addonRecommendations.reason ||
                    "Many travelers also request these medications when heading to your destination. Adding them to your order now is a great way to ensure you're fully prepared and stress-free for your upcoming trip."}
                </AlertBanner.Message>
              </AlertBanner>
              <div className="btn-container">
                <Button
                  data-testid="next-button"
                  size="lg"
                  iconName="ArrowRight"
                  customWidth={440}
                  onClick={submitSelections}
                >
                  Next
                </Button>
              </div>
            </div>
          </div>
        </PageConsultation.Body>
      </div>
    </>
  );
};

export default UpsellPage;
